import { Avatar, Box, Flex, Heading, HStack, Input, InputGroup, InputLeftAddon, Spinner, Text, Textarea, VStack } from "@chakra-ui/react";
import { Divider } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { FiPause, FiPlay } from "react-icons/fi";
import { HiOutlineArrowNarrowLeft } from "react-icons/hi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useQueryClient } from "react-query";
import BrandButton from "../../../components/brandButton/BrandButton";
import { useData } from "../../../data";
import IsDesktop from "../../../utils/IsDesktop";
import share_icon from "../../../public/icons/share_icon.svg";
import copy_icon from "../../../public/icons/copy_icon.svg";
import { useMutation, mutateFunction } from "../../../libs/apis";
import { CustomToast } from "../../../components/toast/CustomToast";
import { copyToClipboard } from "../../../utils/copyToClipboard";

const ViewNewsDetails = ({ news, newsId, onToggle, changeStatus, deleteNews, refetch }) => {
  const isDesktop = IsDesktop();

  const { mutate, isLoading: mutateIsLoading } = useMutation(mutateFunction);
  const { addToast } = CustomToast();
  const [newsDetails, setNewsDetails] = useState(news);
  const [editNewsDetails, setEditNewsDetails] = useState({
    title: news.title, url: news.url, description: news.description
  });
  const queryClient = useQueryClient();


  const changeThisOfferStatus = (newsId) => {
    changeStatus(newsId);
    queryClient.invalidateQueries(`news/${newsId}`);
  };

  const deleteThisNews = (newsId) => {
    deleteNews(newsId);
    onToggle();
  };

  const handleChange = (e) => {
    setEditNewsDetails({ ...editNewsDetails, [e.target.name]: e.target.value })
  }

  const editOffer = () => {
    mutate(
      { key: `news/${newsDetails?.id}`, method: "put", data: editNewsDetails },
      {
        onSuccess(res) {
          addToast(res)
          queryClient.invalidateQueries('news');
          refetch();
          onToggle()
        },
        onError(res) {
          addToast({ message: res?.response?.data?.message || 'Please fill all fields', type: 'error' })
        },
      }
    );

  }

  const copyLink = () => {
    if (newsDetails?.offer_url) {
      copyToClipboard(newsDetails?.offer_url)
      addToast({ message: 'Copied' }, 'info')
    } else {
      addToast({ message: 'News has no link' }, 'info')
    }
  }
  return (
    <>


      <Flex justifyContent="space-between" alignItems="center" my={4} mx={4}>
        <Flex cursor="pointer" onClick={onToggle} justifyContent="flex-start" alignItems="center">
          <Box mr={2}>
            <HiOutlineArrowNarrowLeft size="35px" />
          </Box>
          <Box>
            <Text fontWeight={600}>Back</Text>
          </Box>
        </Flex>
      </Flex>
      <HStack h="600px" w="100%" alignItems="flex-start" m={4}>
        <VStack w="60%">
          <Flex flexDir="column" w="100%" key="title">
            <Text fontSize="14px" mb={2}>
              News Title
            </Text>
            <Input borderWidth="1px" borderColor="brand.primary" borderRadius="5px" focusBorderColor="#" variant="outline" placeholder="News Title" defaultValue={newsDetails?.title} name="title" type="text" w="100%" h="50px" onChange={(e) => handleChange(e)} />
          </Flex>
          <Flex flexDir="column" w="100%" key="url">
            <Text fontSize="14px" mb={2}>
              News URL
            </Text>
            <Input borderWidth="1px" borderColor="brand.primary" borderRadius="5px" focusBorderColor="#" variant="outline" placeholder="News url" defaultValue={newsDetails?.url} name="url" type="text" w="100%" h="50px" onChange={(e) => handleChange(e)} />
          </Flex>
          <Flex flexDir="column" w="100%" key="description">
            <Text fontSize="14px" mb={2}>
              News Description
            </Text>
            <Input borderWidth="1px" borderColor="brand.primary" borderRadius="5px" focusBorderColor="#" variant="outline" placeholder="Url Description" defaultValue={newsDetails?.description} name="description" type="text" w="100%" h="50px" onChange={(e) => handleChange(e)} />
          </Flex>
          <Box className="w-full flex justify-start my-3">
            <BrandButton text="Edit News" isLoading={mutateIsLoading} w="120px" onClick={() => editOffer()} />
          </Box>

        </VStack>
      </HStack>
    </>
  );
};
export default ViewNewsDetails;
